import Vue from 'vue';
import VueRouter from 'vue-router';

import Editor from '@/views/Editor.vue';
import Profile from '@/views/Profile.vue';
import UI from '@/views/UI.vue';
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.use(VueRouter);

const APP_TITLE_PREFIX = 'Орк Нарк';

const routes = [
    {
        path: '/',
        name: 'Main',
        meta: {
            access: false,
            title: `Главная страница | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/Main.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {
            access: true,
            title: `Профиль | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/Profile.vue')
    },
    {
        path: '/editor/:id',
        name: 'Editor',
        meta: {
            access: true,
            title: `Редактор | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/Editor.vue')
    },
    {
        path: '/career_trajectory',
        name: 'CareerTrajectory',
        meta: {
            access: false,
            title: `Карьерная траектория | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/CareerTrajectory.vue')
    },
    {
        path: '/auto-trajectory/:id',
        name: 'AutoTrajectory',
        meta: {
            access: false,
            title: 'Карьерная траектория профессионального стандарта',
        },
        component: () => import('@/views/QualificationAutoInterrelations')

    },
    {
        path: '/documents',
        name: 'Documents',
        meta: {
            access: false,
            title: `Документы | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/Documents.vue')
    },
    {
        path: '/ui',
        name: 'UI',
        meta: {
            access: false,
            title: `UI | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/UI.vue')
    },
    {
        path: '*',
        name: '404',
        meta: {
            access: false,
            title: `404 | ${ APP_TITLE_PREFIX }`,
        },
        component: () => import('@/views/404.vue')
    }
];

const router = new VueRouter({
    routes
});

Vue.use(VueYandexMetrika, {
    id: 81464293,
    router: router,
    env: process.env.NODE_ENV,
    debug: true,
})

// Проставляем title для страниц из meta в роутах
router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    
    const localStorageData = JSON.parse(localStorage.getItem('ork.nark'))

    if (!to.meta.access) next()
    else if (!localStorageData) next({ path: '/' })
    else {
        const accessToken = localStorageData.tokens.accessToken
    
        if (!accessToken) next({ path: '/' })
        else next();
    } 
});

export default router;
